/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useRef } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { IoMdArrowForward, IoMdArrowBack } from 'react-icons/io';
import Carousel from '../Carousels/SingleItemFadeCarousel';
import HomeTestimonialsCard from './HomeTestimonialsCard';
import OptimizedImage from '../OptimizedImage';

const Q = graphql`
  {
    cases: allMarkdownRemark(
      filter: {
        frontmatter: {
          templateKey: { eq: "case-study" }
          published: { ne: false }
        }
      }
    ) {
      edges {
        node {
          id
          frontmatter {
            images {
              logo {
                childImageSharp {
                  fixed(
                    duotone: {
                      highlight: "#cccccc"
                      shadow: "#505050"
                      opacity: 0
                    }
                    width: 140
                    quality: 100
                  ) {
                    ...GatsbyImageSharpFixed_withWebp_noBase64
                  }
                }
              }
            }
            testimonial {
              content
              author {
                title
                subtitle
                photo {
                  childImageSharp {
                    fixed(width: 64, quality: 100) {
                      ...GatsbyImageSharpFixed_withWebp_noBase64
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const HomeTestimonials = ({
  customTitle,
  customSubtitle,
  useSpecificTestimonial
}) => {
  const data = useStaticQuery(Q);
  let cases = data.cases.edges.map(({ node }) => ({
    testimonial: node.frontmatter.testimonial,
    logo: node.frontmatter.images.logo.childImageSharp.fixed,
    id: node.id
  }));

  function filterByAuthor(value) {
    const testimonialExists = value.testimonial && value.testimonial.author;

    return (
      testimonialExists &&
      useSpecificTestimonial.includes(value.testimonial.author.title)
    );
  }
  if (useSpecificTestimonial) {
    cases = cases.filter(filterByAuthor);
  }

  const sliderRef = useRef(null);

  const goNext = () => {
    if (sliderRef !== null) {
      sliderRef.current.next();
    }
  };

  const goPrev = () => {
    if (sliderRef !== null) {
      sliderRef.current.prev();
    }
  };
  return (
    <div className="testimonials">
      <div className="container">
        <OptimizedImage
          background
          src="globe.png"
          className="top-beam"
          style={{
            backgroundPosition: '',
            backgroundRepeat: '',
            backgroundSize: '',
            backgroundAttachment: ''
          }}
        >
          <div className="subtitle without bigger">
            <h2>{customTitle || 'Testimonials'}</h2>
            <h4 className="extra">
              {customSubtitle || 'Customer opinions proves we are trustworthy.'}
            </h4>
          </div>
        </OptimizedImage>
      </div>

      <div className="container">
        <div className="testimonials-slider main-swiper">
          <div className="swiper-container">
            <Carousel ref={sliderRef}>
              {cases
                .filter(caseStudy => {
                  const { testimonial } = caseStudy;
                  if (testimonial && testimonial.author)
                    return testimonial && !!testimonial.author.title;
                })
                .map(caseStudy => {
                  const { testimonial, logo } = caseStudy;
                  return (
                    <div
                      className="swiper-slide swiper-slide-testimonial sw-pv3"
                      key={`testi-${caseStudy.id}`}
                    >
                      <HomeTestimonialsCard
                        testimonial={testimonial}
                        logo={logo}
                      />
                    </div>
                  );
                })}
            </Carousel>
          </div>
          <div className="navigation-slider">
            <div
              className="nav-button nav-left testi-left"
              aria-label="Show previous testimonial"
              role="button"
              onClick={goPrev}
              tabIndex="0"
            >
              <IoMdArrowBack />
            </div>
            <div
              className="nav-button nav-right testi-right"
              aria-label="Show next testimonial"
              role="button"
              tabIndex="0"
              onClick={goNext}
            >
              <IoMdArrowForward />
            </div>
          </div>
          <div className="swiper-pagination sw-pv3" />
        </div>
      </div>
    </div>
  );
};

export default HomeTestimonials;

HomeTestimonials.defaultProps = {
  customTitle: 'Testimonial',
  customSubtitle:
    'Read custom opinions which prove that we are a perfect technology partner for you as well.'
};
